import { ActionReducerMapBuilder, PayloadAction } from "@reduxjs/toolkit";
import { CheckCreditAgentLineReponse } from "api/auth/type";
import { FeatureResponse } from "api/feature/type";
import { ResponseCode } from "contants/response";
import { NoInfer } from "react-redux";
import { FeatureStateType } from "types/feature";

import { getDataPermission, getFeature } from "./feature.thunk";

export const extraReducers = (
  builder: ActionReducerMapBuilder<NoInfer<FeatureStateType>>
) => {
  builder.addCase(getFeature.pending, (state: FeatureStateType) => {
    state.isLoading = true;
  });

  builder.addCase(
    getFeature.fulfilled,
    (state: FeatureStateType, action: PayloadAction<FeatureResponse>) => {
      state.isLoading = false;
      state.toggle = action?.payload?.data?.toggle;
    }
  );

  builder.addCase(getDataPermission.pending, (state: FeatureStateType) => {
    state.isLoading = true;
  });

  builder.addCase(
    getDataPermission.fulfilled,
    (
      state: FeatureStateType,
      action: PayloadAction<CheckCreditAgentLineReponse>
    ) => {
      if (action.payload.status !== ResponseCode.SUCCESS) return;

      state.isLoading = false;
      state.isCreditAgentLine =
        action.payload?.data?.is_credit_agent_line || false;
    }
  );

  builder.addCase(getDataPermission.rejected, (state: FeatureStateType) => {
    state.isLoading = false;
    state.isCreditAgentLine = false;
  });
};
